import { render, staticRenderFns } from "./communicationManagement.vue?vue&type=template&id=fd3fc50e&scoped=true"
import script from "./communicationManagement.vue?vue&type=script&lang=js"
export * from "./communicationManagement.vue?vue&type=script&lang=js"
import style0 from "./communicationManagement.vue?vue&type=style&index=0&id=fd3fc50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3fc50e",
  null
  
)

export default component.exports